import { createI18n } from "vue-i18n";
import { en, fr, de } from "@esenda/core-ui/translations";

// List of supported languages
const supportedLocales = {
    "en-GB": en,
    "fr-FR": fr,
    "de-DE": de,
};

// Return the language from the store if it exists
const store = JSON.parse(sessionStorage.getItem("session") || "{}");
const userLocale = store?.language || navigator.language;
// Check if the local language is supported. If not, use "en-GB" as a fallback.
const locale = Object.keys(supportedLocales).includes(userLocale)
    ? userLocale
    : "en-GB";

const i18n = createI18n({
    locale,
    fallbackLocale: "en-GB",
    allowComposition: true,
    messages: supportedLocales,
});

/**
 * Checks if the key exist in the list of internationalised messages.
 * It checks in the "en-GB" locale for now as we do not have any other
 * translation languages enabled. Once we add more language support, we
 * can change the "en-GB" value to the user's locale
 * @param {string} key
 * @returns {boolean}
 */
export const translationExists = (key: string): boolean => {
    return (i18n.global as { te: (k: string, l?: string) => boolean }).te(
        key,
        locale,
    );
};

export default i18n;
